import { ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Observable, Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { TaskService } from 'src/app/services/task.service';
import { AlertComponent } from '../structure/alert/alert.component';
import { ProcessMasterService } from 'src/app/services/process-master.service';
declare var $: any;
import * as _ from 'lodash';
import { SharerService } from 'src/app/services/sharer.service';
import { companyTask } from '../structure/compliance/companyTask';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';


@Component({
  selector: 'app-unapproved-task-list',
  templateUrl: './unapproved-task-list.component.html',
  styleUrls: ['./unapproved-task-list.component.css']
})
export class UnapprovedTaskListComponent implements OnInit, OnDestroy {

  public environmentSettings: any;
  private loaderTimeout: any;

  @ViewChild(DataTableDirective)
  dtElementforPeriodicTask: DataTableDirective;
  dtOptionsforPeriodicTask: any = {};
  dtTriggerforPeriodicTask: Subject<any> = new Subject();

  dtElements: QueryList<DataTableDirective>;

  checkAllPeriodicTask: any;

  @ViewChild(DataTableDirective)
  dtElementforEventBasedTask: DataTableDirective;
  dtOptionsEventBasedTask: any = {};
  dtTriggerEventBasedTask: Subject<any> = new Subject();


  // @ViewChild(DataTableDirective)
  // dtElement: DataTableDirective;
  // dtOptions: any = {};
  // The trigger needed to re-render the table
  // dtTrigger: Subject<any> = new Subject();
  activateTasksForm: FormGroup;
  taskConfigurationForm: FormGroup;
  groupTypes: any[];
  companytasklist: any[];
  //selectedCompanytasks: any[];
  selectedAllEventTask: any;
  selectedAllPeriodicTask: any;
  meetingTypes: any[];
  meetingtypeId: string;
  meetingType: string;
  IsSelectedTasks: any;
  groupID: any;
  taskID: any;
  processes: any[];
  processType: string;
  // SearchtaskEventbasedorPeriodicModel: any;
  // SearchtaskUserdefinedorPredefinedModel: any;
  SearchtaskUserdefinedorPredefinedModelEventTask: any;
  SearchtaskUserdefinedorPredefinedModelPeriodicTask: any;
  taskStatus: any;
  isInactiveTask: any;
  countOfSelectedtask: any;
  countOfDeSelectedtask: any;
  groupname: any = null;
  selcettaskname: any = null;
  erroMessage: boolean = false;

  selectedCompanytasks: companyTask[] = [];
  hasPermission: any;
  currentURL: any;
  searcheFilteredDataEventTask: any[];
  searcheFilteredDataPeriodicTask: any[];
  newselectflag: any;
  togglecount: any;
  searchvalue: any;
  response: boolean;
  isSearchCollapsed: boolean = true;
  searchParamEvent: any = {};
  searchParam: any = {};
  triggerTypeofEventBased: any;
  triggerTypeofPeriodicBased: any;
  libraryEventBasedTaskList: any[] = [];
  libraryPeriodicBasedTaskList: any[] = [];
  UserListData: any;
  private cachedUsersList$: Observable<any> | null = null;
  private cachedEventTaskList$: Observable<any> | null = null;
  private cachedPeriodicTaskList$: Observable<any> | null = null;
  private cachedEventTriggerTypes$: Observable<any> | null = null;
  private cachedPeriodicTriggerTypes$: Observable<any> | null = null;
  private isTasksDataLoaded: boolean = false;
  count: number = 0;
  isLoading: boolean = false;


  periodicTaskList: any[] = [];

  searchPeriodicParam: any = {};
  searcheFilteredDataTask: any[];

  assignedusers: any[];
  isPeriodicConfigurationAvailable: boolean = false;
  configId: any;
  disabledOnclick: boolean;
  taskTriggerTypes: any[];
  approveStatusId: any;
  taskRejectComment: any;
  approveCheck: any;
  approveBtnType: any;
  approveMultipleBtnType: any;
  public ipLocalPc: any;
  saveType: any;
  taskParticulars: any;
  cnt = 0;
  isCheckerRole: boolean = false;
  private eventBasedTable: DataTables.Api;
  private periodicTable: DataTables.Api;
  private isTablesInitialized = false;

  constructor(private taskService: TaskService, private loaderService: LoaderService, private cdRef: ChangeDetectorRef, private route: ActivatedRoute, private groupMasterService: GroupMasterService, private processService: ProcessMasterService, private router: Router, private commonFunction: CommonFunction, private alert: AlertComponent, private sharerService: SharerService) {
    this.currentURL = window.location.href;
    this.togglecount = 0;
    this.response = false;
    this.searchParamEvent =
    {
      // "SearchtaskUserdefinedorPredefinedModel": null,
      "SearchtaskUserdefinedorPredefinedModelPeriodicTask": null,
      "SearchtaskUserdefinedorPredefinedModelEventTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null,
      "triggerId": null
    }
    this.searchParam =
    {
      // "SearchtaskUserdefinedorPredefinedModel": null,
      "SearchtaskUserdefinedorPredefinedModelPeriodicTask": null,
      "SearchtaskUserdefinedorPredefinedModelEventTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null,
      "triggerId": null,
      "ApproveStatus": null
    }

    this.searchPeriodicParam = {
      "SearchtaskUserdefinedorPredefinedModelPeriodicTask": null,
      "SearchtaskUserdefinedorPredefinedModelEventTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null,
      "triggerId": null,
      "ApproveStatus": null
    }
  }

  toggleSearchCollapse() {
    this.isSearchCollapsed = !this.isSearchCollapsed;
  }

  ngOnDestroy(): void {
    this.stopLoader();
    // Clear cached Observables to prevent memory leaks
    this.cachedUsersList$ = null;
    this.cachedEventTaskList$ = null;
    this.cachedPeriodicTaskList$ = null;
    this.cachedEventTriggerTypes$ = null;
    this.cachedPeriodicTriggerTypes$ = null;
  }

  private startLoader(): void {
    this.loaderService.enable();
    if (this.loaderTimeout) {
      clearTimeout(this.loaderTimeout);
    }
    this.loaderTimeout = setTimeout(() => {
      this.loaderService.disable();
      this.loaderTimeout = null;
    }, 5000);
  }

  private stopLoader(): void {
    if (this.loaderTimeout) {
      clearTimeout(this.loaderTimeout);
      this.loaderTimeout = null;
    }
    this.loaderService.disable();
  }

  getUserList() {
    // Cache the Observable to prevent multiple HTTP calls
    if (!this.cachedUsersList$) {
      // Use shareReplay(1) to cache the result and share it among all subscribers
      this.cachedUsersList$ = this.taskService.getUsersList().pipe(shareReplay(1));
    }
    
    this.cachedUsersList$.subscribe(userlist => {
      if (userlist.status == 0) {
        this.UserListData = userlist.result;
      }
    })
  }
  
  // Get cached users list Observable
  getCachedUsersList(): Observable<any> {
    if (!this.cachedUsersList$) {
      // Use shareReplay(1) to cache the result and share it among all subscribers
      this.cachedUsersList$ = this.taskService.getUsersList().pipe(shareReplay(1));
    }
    return this.cachedUsersList$;
  }

  //get task assigned user
  getAssignTo(AssignedTo) {
    if (AssignedTo) {
      var assignedTo = _.filter(this.UserListData, ["_id", AssignedTo]);
      var AssignedUserName = (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : ""
      return AssignedUserName;
    } else {
      return ' ';
    }
  }



  // Get cached event task list Observable
  // Note: triggerType parameter is ignored after first call to ensure single service call
  getCachedEventTaskList(triggerType: string = '2'): Observable<any> {
    if (!this.cachedEventTaskList$) {
      // Use shareReplay(1) to cache the result and share it among all subscribers
      // Always use '2' for event tasks to ensure consistency
      this.cachedEventTaskList$ = this.taskService.getCompanyLibraryEventBasedTask('2', false).pipe(shareReplay(1));
    }
    return this.cachedEventTaskList$;
  }

  // Get cached periodic task list Observable
  // Note: triggerType parameter is ignored after first call to ensure single service call
  getCachedPeriodicTaskList(triggerType: string = '1'): Observable<any> {
    if (!this.cachedPeriodicTaskList$) {
      // Use shareReplay(1) to cache the result and share it among all subscribers
      // Always use '1' for periodic tasks to ensure consistency
      this.cachedPeriodicTaskList$ = this.taskService.getCompanyLibraryPeriodicBasedTask('1', false).pipe(shareReplay(1));
    }
    return this.cachedPeriodicTaskList$;
  }

  // Modified getCompanyTaskList()
  async getCompanyTaskList() {
    // If data is already loaded, just update the tables without making new service calls
    if (this.isTasksDataLoaded && this.libraryEventBasedTaskList && this.periodicTaskList) {
      this.response = false;
      if (!this.isTablesInitialized) {
        this.initializeDataTables();
        this.isTablesInitialized = true;
      } else {
        this.updateDataTables();
      }
      return;
    }

    this.isLoading = true;
    this.startLoader();
    this.response = true;

    try {
      const [eventResponse, periodicResponse, usersResponse] = await Observable.forkJoin([
        this.getCachedEventTaskList('2'),
        this.getCachedPeriodicTaskList('1'),
        this.getCachedUsersList()
      ]).toPromise();

      const usersData = usersResponse.result || [];

      // Process tasks
      this.libraryEventBasedTaskList = this.processTasks(eventResponse.tasksDatalist?.TasksData || [], usersData);
      this.periodicTaskList = this.processTasks(periodicResponse.tasksDatalist?.TasksData || [], usersData);
      this.isTasksDataLoaded = true;

      this.response = false;

      // Initialize or update tables
      if (!this.isTablesInitialized) {
        this.initializeDataTables();
        this.isTablesInitialized = true;
      } else {
        this.updateDataTables();
      }

    } catch (error) {
      console.error('Error loading tasks:', error);
      this.response = false;
      this.alert.error('Failed to load tasks');
    } finally {
      this.isLoading = false;
      this.stopLoader();
    }
  }

  private processTasks(tasks: any[], users: any[]): any[] {
    return tasks.map(task => {
      const assignedTo = _.find(users, ["_id", task.AssignedTo]);
      const responsibleUser = _.find(users, ["_id", task.ResponsibleUser]);

      return {
        ...task,
        AssignedUserName: assignedTo ? `${assignedTo.FirstName} ${assignedTo.LastName}` : "",
        ResponsibleUserName: responsibleUser ? `${responsibleUser.FirstName} ${responsibleUser.LastName}` : "",
        SelectedTask: false
      };
    });
  }

  private initializeDataTables() {
    // Event based table
    setTimeout(() => {
      this.eventBasedTable = $('#eventLiberyTaskTable').DataTable(this.dtOptionsEventBasedTask);
    });

    // Periodic table
    setTimeout(() => {
      this.periodicTable = $('#PeriodicTaskDataTable').DataTable(this.dtOptionsforPeriodicTask);
    });
  }

  private updateDataTables() {
    // Destroy existing instances if they exist
    if (this.eventBasedTable) {
      this.eventBasedTable.destroy();
    }
    if (this.periodicTable) {
      this.periodicTable.destroy();
    }

    // Reinitialize
    this.initializeDataTables();
  }

  // Add these tab switch handlers
  onTabSwitch(tab: 'event' | 'periodic') {
    setTimeout(() => {
      if (tab === 'event' && this.eventBasedTable) {
        this.eventBasedTable.columns.adjust().draw();
      } else if (tab === 'periodic' && this.periodicTable) {
        this.periodicTable.columns.adjust().draw();
      }
    }, 100);
  }
  // Helper method to rerender DataTables
  private rerenderDataTables(): void {
    // Rerender event based task table
    if (this.dtElementforEventBasedTask?.dtInstance) {
      this.dtElementforEventBasedTask.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTriggerEventBasedTask.next();
      });
    } else {
      this.dtTriggerEventBasedTask.next();
    }

    // Rerender periodic task table
    if (this.dtElementforPeriodicTask?.dtInstance) {
      this.dtElementforPeriodicTask.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTriggerforPeriodicTask.next();
      });
    } else {
      this.dtTriggerforPeriodicTask.next();
    }
  }

  getProcessList() {
    this.processes = [];

    this.processService.getProcessList()
      .subscribe(processList => {
        if (processList.status == 0) {
          this.processes = processList.processList;
          this.processes = this.commonFunction.sortByKey(this.processes, 'ProcessName');
        }
      })
  }

  deleteTask() {
    if (this.environmentSettings.TaskMakerChecker) {
      this.taskService.unapproveTaskBeforeDelete(this.taskID).subscribe(response => {
        if (response.status == 0) {
          this.getCompanyTaskList();
          $('#confirmationEventTask').modal('toggle');
          this.alert.success('Task deleted successfully');
        } else {
          this.getCompanyTaskList();
          this.alert.error('Oops, something went wrong')
        }
      })
    } else {
      this.taskService.deletePredefinedCompanyTask(this.taskID).subscribe((data: any) => {
        if (data.status == 0) {
          $('#confirmationEventTask').modal('toggle');
          this.alert.success(data.message);
        }
        else {
          $('#confirmationEventTask').modal('toggle');
          this.alert.error(data.message);
        }

        this.getCompanyTaskList();

      });
    }
  }

  getProcessListByProcessType(processType) {
    this.processes = [];
    var ispredefined = null;
    if (processType === 'Predefined') {
      ispredefined = true;
    } else if (processType === 'Userdefined') {
      ispredefined = false;
    }

    this.processService.getProcessList()
      .subscribe(processList => {
        if (processList.status == 0) {
          var processData = $(processList.processList).filter(function (i, n) { return n.IsPredefined === ispredefined });
          this.processes = this.commonFunction.sortByKey(processData, 'ProcessName');;
        }
      })
  }

  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList: any) => {
        if (groupList.status == 0) {
          //this.groupTypes = groupList.groupList;
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }


  addTaskstoProcess() {
    this.disabledOnclick = true;
    //var companyID = JSON.parse(localStorage.getItem("selectedCompanyID"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    for (let result of this.libraryEventBasedTaskList) {
      if (result.SelectedTask === true) {

        result.CompanyID = companyID;
        result.ProcessID = this.activateTasksForm.controls.ProcessID.value;
        this.selectedCompanytasks.push(result);
      }

    }

    var processTasksData = {
      processTasks: this.selectedCompanytasks
    }
    //this.taskService.updateCompanyTasks(companyTasks)

    this.taskService.addTaskstoProcess(processTasksData)
      .subscribe((result: any) => {
        this.disabledOnclick = false;
        if (result.status == 0) {

          $('#addtasktoprocessDialogEventTask').modal('toggle');
          $('#addtasktoprocessDialog').modal('toggle');
          const processId = this.activateTasksForm.controls.ProcessID.value;
          // this.router.navigate(['/processTasks/', processId]);
          //this.alert.successWithOk(result.message, '/process/tasks/' + processId);
          this.alert.successWithOk(result.message, '/process/edit/' + processId);

        }
        else {
          this.alert.error(result.message);
        }

        // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        //   dtInstance.destroy();
        // });
        $("html, body").animate({ scrollTop: 0 }, "slow");

        this.getCompanyTaskList();
        this.selectedCompanytasks = [];
        this.IsSelectedTasks = false;
        // $("#btnsaveTasktoProcess .close").click()
      });
  }


  companyTaskListBySearchFilter(searchParameters) {
    this.companytasklist = [];

    // this.taskService.getCompanyTaskListBySearchFilters(searchParameters)
    this.taskService.getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParameters, false)
      .subscribe(taskList => {
        // console.log("tasklist", taskList);
        if (taskList.status == 0) {
          // this.companytasklist = taskList.tasksDatalist.TasksData;
          var loginUser = JSON.parse(localStorage.getItem('user'));
          this.companytasklist = taskList.data;
          // this.companytasklist = taskList.data.filter(function (ele) {
          //   return ele.CreatedBy != loginUser._id
          // })
          this.response = false;
          this.dtTriggerforPeriodicTask.next();
        }

      })
  }


  eventBasedCount: number = 0;

  periodicBasedCount: number = 0;

  activatedTaskCount: number = 0
  deactivatedTaskCount: number = 0;

  checkselected(ev, isActiveTask) {
    $('[data-toggle="tooltip"]').tooltip();

    // console.log("checkselected", isActiveTask, ev);

    this.cnt = 0;

    if (ev.target.checked == true && isActiveTask) {
      this.cnt = this.cnt + 1;
      this.deactivatedTaskCount = this.deactivatedTaskCount + 1;
      this.periodicTaskCheck = true;
    } else if (ev.target.checked == true && !isActiveTask) {
      this.activatedTaskCount = this.activatedTaskCount + 1;
      this.cnt = this.cnt + 1;
      this.periodicTaskCheck = true;
    }
    else if (ev.target.checked == false && isActiveTask) {
      this.deactivatedTaskCount = this.deactivatedTaskCount - 1;
      this.cnt = this.cnt - 1;
      if (this.cnt > 0) {
        this.periodicTaskCheck = true;
      } else {
        this.periodicTaskCheck = false;
      }


    } else if (ev.target.checked == false && !isActiveTask) {
      this.activatedTaskCount = this.activatedTaskCount - 1;
      this.cnt = this.cnt - 1;
      if (this.cnt > 0) {
        this.periodicTaskCheck = true;
      } else {
        this.periodicTaskCheck = false;
      }
    }
  }

  addToProcessEventTask: any;
  periodicTaskCheck: any;

  checkselectedEvent(ev, isActiveTask, triggerType) {

    if (ev.target.checked == true) {
      this.count = this.count + 1;
      this.IsSelectedTasks = true;
      this.addToProcessEventTask = true;
    } else {
      this.count = this.count - 1;
      if (this.count > 0) {
        this.IsSelectedTasks = true;
        this.addToProcessEventTask = true;
      } else {
        this.IsSelectedTasks = false;
        this.addToProcessEventTask = false;
      }
    }

    // this.setVisibilityOfButtons();

  }

  isEventBaseSelected: boolean = false;
  isPeriodicSelected: boolean = false;

  setVisibilityOfButtons() {
    //if active and inactive task selected
    if (this.countOfSelectedtask > 0 && this.countOfDeSelectedtask > 0) {
      this.IsSelectedTasks = false;
      this.isInactiveTask = false;
    }
    else if (this.countOfSelectedtask > 0) {
      this.IsSelectedTasks = true;
    }
    else if (this.countOfDeSelectedtask > 0) {
      this.isInactiveTask = true;
    }
    else // if both are not selected
    {
      this.IsSelectedTasks = false;
      this.isInactiveTask = false;
    }
    if (this.eventBasedCount > 0) {
      this.isEventBaseSelected = true;
    } else {
      this.isEventBaseSelected = false;
    }
    if (this.periodicBasedCount > 0) {
      this.isPeriodicSelected = true;
    } else {
      this.isPeriodicSelected = false;
    }


  }

  showTasksBySearchDataEventTask(searchParamEvent) {

    this.response = true;
    this.countOfDeSelectedtask = 0;
    this.countOfSelectedtask = 0;
    if (this.taskStatus == 'null') {
      this.taskStatus = "";
    }
    // localStorage.setItem('groupid', this.groupID);
    // localStorage.setItem('taskstatus', this.taskStatus);
    // localStorage.setItem('false', 'true');
    // localStorage.setItem('companyinputdata', JSON.stringify(this.searchParamEvent));
    if ($.fn.DataTable.isDataTable('#eventLiberyTaskTable')) {
      $("#eventLiberyTaskTable").DataTable().destroy();
    }
    // Use cached Observable instead of direct service call
    let usersList = this.getCachedUsersList();
    let eventTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterEventTask(searchParamEvent, false)
    var loginUser = JSON.parse(localStorage.getItem('user'));
    // eventTaskList = eventTaskList.filter(function (ele) {
    //   return ele.CreatedBy != loginUser._id
    // })
    this.isLoading = true;
    this.startLoader();
    Observable.forkJoin([eventTaskList, usersList])
      .subscribe(
        (response) => {
          const libraryEventBasedTaskListdata = response[0]?.data || [];
          const usersData = response[1]?.result || [];
          const tasksDataEvent = [];
          _.forEach(libraryEventBasedTaskListdata, function (activatedTask) {
            const assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
            _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" });
            const responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
            _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });
            tasksDataEvent.push(activatedTask);
          });
          this.libraryEventBasedTaskList = tasksDataEvent;
          this.response = false;
          this.dtTriggerEventBasedTask.next();
          this.isLoading = false;
          this.stopLoader();
        },
        (error) => {
          console.error('Error loading unapproved event search data', error);
          this.response = false;
          this.libraryEventBasedTaskList = [];
          if ($.fn.DataTable.isDataTable('#eventLiberyTaskTable')) {
            $("#eventLiberyTaskTable").DataTable().destroy();
          }
          this.isLoading = false;
          this.stopLoader();
        }
      );

    // this.taskService.getCompanyLibraryTaskListBySearchFilterEventTask(searchParamEvent)
    //   .subscribe(taskList => {
    //     if (taskList.status == 0) {
    //       this.libraryEventBasedTaskList = taskList.data;
    //       this.response = false;
    //       this.dtTriggerEventBasedTask.next();
    //     }

    //   })


  }


  showTasksBySearchDataPeriodic(searchParam) {

    this.libraryPeriodicBasedTaskList = [];
    // Use cached Observable instead of direct service call
    let usersList = this.getCachedUsersList();
    let periodicTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParam, false);
    var loginUser = JSON.parse(localStorage.getItem('user'));
    // periodicTaskList = periodicTaskList.filter(function (ele) {
    //   return ele.CreatedBy != loginUser._id
    // })
    this.isLoading = true;
    this.startLoader();
    Observable.forkJoin([periodicTaskList, usersList])
      .subscribe(
        (response) => {
          const periodicTaskListdata = response[0]?.data || [];
          const usersData = response[1]?.result || [];
          const tasksDataperiodic = [];

          _.forEach(periodicTaskListdata, function (activatedTask) {
            const assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
            _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" });
            const responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
            _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });
            tasksDataperiodic.push(activatedTask);
          })

          this.activatedTaskCount = 0;
          this.deactivatedTaskCount = 0;
          if ($.fn.DataTable.isDataTable('#PeriodicTaskDataTable')) {
            $("#PeriodicTaskDataTable").DataTable().destroy();
          }
          this.periodicTaskList = tasksDataperiodic;
          this.response = false;
          this.dtTriggerforPeriodicTask.next();
          this.isLoading = false;
          this.stopLoader();
        },
        (error) => {
          console.error('Error loading unapproved periodic search data', error);
          this.response = false;
          this.periodicTaskList = [];
          if ($.fn.DataTable.isDataTable('#PeriodicTaskDataTable')) {
            $("#PeriodicTaskDataTable").DataTable().destroy();
          }
          this.isLoading = false;
          this.stopLoader();
        }
      );

    // this.taskService.getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParam)
    //   .subscribe(taskList => {
    //     if (taskList.status == 0) {

    //       this.activatedTaskCount = 0;
    //       this.deactivatedTaskCount = 0;
    //       this.periodicTaskList = [];
    //       $("#PeriodicTaskDataTable").DataTable().destroy();
    //       this.periodicTaskList = taskList.data;
    //       this.response = false;
    //       this.dtTriggerforPeriodicTask.next();

    //     }

    //   })

  }

  //Show all task of periodic task
  showAllPeriodicTasks() {

    localStorage.setItem('false', 'false');
    // this.response = true;
    this.searchPeriodicParam = {
      "SearchtaskUserdefinedorPredefinedModelPeriodicTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null,
      "ApproveStatus": null
    }
    // If data is already loaded OR cache exists, use cached data directly without making service call
    if ((this.isTasksDataLoaded && this.periodicTaskList && this.periodicTaskList.length > 0) || 
        (this.cachedPeriodicTaskList$ && this.periodicTaskList && this.periodicTaskList.length > 0)) {
      // Use cached data directly
      this.activatedTaskCount = 0;
      this.deactivatedTaskCount = 0;
      if ($.fn.DataTable.isDataTable('#PeriodicTaskDataTable')) {
        $("#PeriodicTaskDataTable").DataTable().destroy();
      }
      this.response = false;
      this.dtTriggerforPeriodicTask.next();
      return;
    }

    // Use cached Observable instead of direct service call
    // This will only make a service call if cache doesn't exist
    let usersList = this.getCachedUsersList();
    let periodicTaskList = this.getCachedPeriodicTaskList(this.triggerTypeofEventBased || '1');
    var loginUser = JSON.parse(localStorage.getItem('user'));
    // periodicTaskList = periodicTaskList.filter(function (ele) {
    //   return ele.CreatedBy != loginUser._id
    // })
    this.isLoading = true;
    this.startLoader();
    Observable.forkJoin([periodicTaskList, usersList])
      .subscribe(
        (response) => {
          const periodicTaskListdata = response[0].tasksDatalist.TasksData;
          const usersData = response[1].result;
          const tasksDataperiodic = [];

          // AssignedTo , CreatedBy 
          _.forEach(periodicTaskListdata, function (activatedTask) {
            var assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
            _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" })
            var responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
            _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });

            tasksDataperiodic.push(activatedTask);
          })
          this.activatedTaskCount = 0;
          this.deactivatedTaskCount = 0;
          $("#PeriodicTaskDataTable").DataTable().destroy();
          this.periodicTaskList = tasksDataperiodic;
          this.isTasksDataLoaded = true;
          this.response = false;
          this.dtTriggerforPeriodicTask.next();
          this.isLoading = false;
          this.stopLoader();
        },
        (error) => {
          console.error('Error loading all periodic tasks', error);
          this.response = false;
          this.periodicTaskList = [];
          if ($.fn.DataTable.isDataTable('#PeriodicTaskDataTable')) {
            $("#PeriodicTaskDataTable").DataTable().destroy();
          }
          this.isLoading = false;
          this.stopLoader();
        }
      );
    // this.taskService.getCompanyLibraryPeriodicBasedTask(this.triggerTypeofEventBased)
    //   .subscribe(taskList => {
    //     if (taskList.status == 0) {
    //       this.activatedTaskCount = 0;
    //       this.deactivatedTaskCount = 0;
    //       this.periodicTaskList = [];
    //       $("#PeriodicTaskDataTable").DataTable().destroy();
    //       this.periodicTaskList = taskList.tasksDatalist.TasksData;
    //       this.response = true;
    //       this.dtTriggerforPeriodicTask.next();
    //     }
    //   })
  }

  //Show all task of event task
  showAllEventTasks() {

    localStorage.setItem('searchcompanytask', 'false');
    this.searchParam = {
      "SearchtaskUserdefinedorPredefinedModelEventTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null
    }
    // If data is already loaded OR cache exists, use cached data directly without making service call
    if ((this.isTasksDataLoaded && this.libraryEventBasedTaskList && this.libraryEventBasedTaskList.length > 0) ||
        (this.cachedEventTaskList$ && this.libraryEventBasedTaskList && this.libraryEventBasedTaskList.length > 0)) {
      // Use cached data directly
      if ($.fn.DataTable.isDataTable('#eventLiberyTaskTable')) {
        $('#eventLiberyTaskTable').DataTable().destroy();
      }
      this.response = false;
      this.dtTriggerEventBasedTask.next();
      return;
    }

    // Use cached Observable instead of direct service call
    // This will only make a service call if cache doesn't exist
    let usersList = this.getCachedUsersList();
    let eventTaskList = this.getCachedEventTaskList(this.triggerTypeofEventBased || '2');

    var loginUser = JSON.parse(localStorage.getItem('user'));
    // eventTaskList = eventTaskList.filter(function (ele) {
    //   return ele.CreatedBy != loginUser._id
    // })

    this.isLoading = true;
    this.startLoader();
    Observable.forkJoin([eventTaskList, usersList])
      .subscribe(
        (response) => {
          const libraryEventBasedTaskListdata = response[0]?.tasksDatalist?.TasksData || [];
          const usersData = response[1]?.result || [];
          const tasksDataEvent = [];
          _.forEach(libraryEventBasedTaskListdata, function (activatedTask) {
            const assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
            _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" })
            const responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
            _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });
            tasksDataEvent.push(activatedTask);
          });

          if ($.fn.DataTable.isDataTable('#eventLiberyTaskTable')) {
            $('#eventLiberyTaskTable').DataTable().destroy();
          }
          this.libraryEventBasedTaskList = tasksDataEvent;
          this.isTasksDataLoaded = true;
          this.response = false;
          this.dtTriggerEventBasedTask.next();
          this.isLoading = false;
          this.stopLoader();
        },
        (error) => {
          console.error('Error loading unapproved event tasks', error);
          this.response = false;
          this.libraryEventBasedTaskList = [];
          if ($.fn.DataTable.isDataTable('#eventLiberyTaskTable')) {
            $('#eventLiberyTaskTable').DataTable().destroy();
          }
          this.isLoading = false;
          this.stopLoader();
        }
      );



    // this.taskService.getCompanyLibraryEventBasedTask(this.triggerTypeofEventBased)
    //   .subscribe(taskList => {
    //     if (taskList.status == 0) {
    //       this.libraryEventBasedTaskList = [];
    //       $("#eventLiberyTaskTable").DataTable().destroy();
    //       this.libraryEventBasedTaskList = taskList.tasksDatalist.TasksData;
    //       this.response = true;
    //       this.dtTriggerEventBasedTask.next();
    //     }
    //   })
  }

  //For enable event task serch button
  searchEventEnable() {
    this.response = false;
  }

  showaddTasktoProcessDialog() {

    this.activateTasksForm.controls.ProcessID.setValidators([Validators.required]);
    this.activateTasksForm.controls.ProcessID.updateValueAndValidity();
    this.activateTasksForm.controls.TaskParticulars.clearValidators();
    this.activateTasksForm.controls.TaskParticulars.updateValueAndValidity();
    //this.taskForm.controls.TaskParticulars.updateValueAndValidity();
  }

  activateTasks() {
    // console.log('');
    this.response = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    for (let result of this.libraryEventBasedTaskList) {
      if (result.SelectedTask === true) {

        var selectedCompanytask = new companyTask
        selectedCompanytask.TaskParticulars = this.activateTasksForm.controls.TaskParticulars.value;
        selectedCompanytask.ID = result.ID;
        selectedCompanytask.TaskID = result.TaskID;
        selectedCompanytask.TaskName = result.TaskName;
        //result.ID=result.TasksData.ID;
        selectedCompanytask.CompanyID = companyID;
        selectedCompanytask.ProcessID = null;
        this.selectedCompanytasks.push(selectedCompanytask);

      }

    }

    var companyTasks = {
      activateCompanyTasks: this.selectedCompanytasks
    }
    //this.taskService.updateCompanyTasks(companyTasks)
    this.taskService.activateCompanyTasks(companyTasks)
      .subscribe(result => {

        if (result.status == 0) {
          //this.alert.success(result.message);
          this.alert.successWithOk(result.message, '/tasks/activated');
          this.checkAllPeriodicTask = false;
        }
        else {
          this.alert.error(result.message);
        }

      });
  }


  deselectTasksPerodicTask() {
    let isAllPeriodic = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    for (let result of this.periodicTaskList) {
      // console.log('result.SelectedTask', result.SelectedTask);
      if (result.SelectedTask === true) {
        var selectedCompanytask = new companyTask
        selectedCompanytask.ID = result.ID;
        selectedCompanytask.TaskID = result.TaskID;
        selectedCompanytask.TaskName = result.TaskName;
        selectedCompanytask.CompanyID = companyID;
        selectedCompanytask.ProcessID = null;
        selectedCompanytask.TriggerType = result.TriggerType;
        this.selectedCompanytasks.push(selectedCompanytask);
        if (this.selectedCompanytasks[0].TriggerType == '1') {
          isAllPeriodic = false;
        }
      }

    }
    if (isAllPeriodic) {
      var companyTasks = {
        deSelectCompanyTasks: this.selectedCompanytasks
      }

      this.taskService.deSelectCompanyTasks(companyTasks)
        .subscribe(result => {

          if (result.status == 0) {
            this.alert.success(result.message);
            this.isPeriodicSelected = false;

          }
          else {
            this.alert.error(result.message);
          }

          this.getCompanyTaskList();
          this.selectedCompanytasks = [];
          this.IsSelectedTasks = false;
          this.selectedAllPeriodicTask = false;
          this.isInactiveTask = false;
          this.countOfSelectedtask = 0;
          this.countOfDeSelectedtask = 0;
          this.activatedTaskCount = 0;
          this.deactivatedTaskCount = 0;
          this.checkAllPeriodicTask = false;

        });
    } else {
      this.alert.error('Please select Periodic Task Only for Deactivation.');
    }


  }

  //added on 19 May-- selected task to make active
  selectTasks() {

    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    for (let result of this.periodicTaskList) {
      if (result.SelectedTask === true) {
        var selectedCompanytask = new companyTask
        selectedCompanytask.ID = result.ID;
        selectedCompanytask.TaskID = result.TaskID;
        selectedCompanytask.TaskName = result.TaskName;
        selectedCompanytask.CompanyID = companyID;
        selectedCompanytask.ProcessID = null;
        this.selectedCompanytasks.push(selectedCompanytask);
      }
    }

    var companyTasks = {
      selectCompanyTasks: this.selectedCompanytasks
    }

    this.taskService.selectCompanyTasks(companyTasks)
      .subscribe(result => {
        if (result.status == 0) {
          this.alert.success(result.message);
        }
        else {
          this.alert.error(result.message);
        }

        this.getCompanyTaskList();
        this.selectedCompanytasks = [];
        this.IsSelectedTasks = false;
        this.selectedAllEventTask = false;
        this.selectedAllPeriodicTask = false;
        this.isInactiveTask = false;
        this.countOfSelectedtask = 0;
        this.countOfDeSelectedtask = 0;
        this.activatedTaskCount = 0;
        this.deactivatedTaskCount = 0;
      });
  }

  EditEventBasedTask(taskId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['updateTask', taskId] } }],
      { relativeTo: this.route.parent });
  }

  EditPeriodicBasedTask(taskId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['updateTask', taskId] } }],
      { relativeTo: this.route.parent });
  }


  // function to check wheather all checkbox select or not 
  toggleEditableCheckboxEvent(event) {
    if (event.target.checked) {
      this.erroMessage = true;
    } else {
      this.erroMessage = false;
      this.isEventBaseSelected = false;
      this.isPeriodicSelected = false;
      this.eventBasedCount = 0;
      this.periodicBasedCount = 0;
    }

  }

  // Select all Event task
  selectAllEventTask() {

    if (this.searcheFilteredDataEventTask) {

      for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {

        for (var j = 0; j < this.searcheFilteredDataEventTask.length; j++) {
          if (this.searcheFilteredDataEventTask[j] == this.libraryEventBasedTaskList[i].TaskID) {
            this.libraryEventBasedTaskList[i].SelectedTask = this.selectedAllEventTask;
            this.IsSelectedTasks = this.selectedAllEventTask;

            //added on 21 May -- to hide deselect button or select button
            //after checked all tasks- find out if active or inactive task exists   

            if (this.selectedAllEventTask == true) {
              if (this.libraryEventBasedTaskList[i].IsActive == true) {
                this.countOfSelectedtask = this.countOfSelectedtask + 1;
              }
              else if (this.libraryEventBasedTaskList[i].IsActive == false) {
                this.countOfDeSelectedtask = this.countOfDeSelectedtask + 1;
              }
            }
          }
        }

      }
      this.selectedAllEventTask = false;
      this.IsSelectedTasks = false;

    }
    else {
      this.selectedAllEventTask = true;
      for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
        this.libraryEventBasedTaskList[i].SelectedTask = this.selectedAllEventTask;
        this.IsSelectedTasks = this.selectedAllEventTask;
        //added on 21 May -- to hide deselect button or select button
        //after checked all tasks- find out if active or inactive task exists   
        if (this.selectedAllEventTask == true) {
          if (this.libraryEventBasedTaskList[i].IsActive == true) {
            this.countOfSelectedtask = this.countOfSelectedtask + 1;
          }
          else if (this.libraryEventBasedTaskList[i].IsActive == false) {
            this.countOfDeSelectedtask = this.countOfDeSelectedtask + 1;
          }
        }

      }


    }

    //to hide deselect button or select button
    this.setVisibilityOfButtons();

  }

  // Select all Periodic task
  selectedAllPeriodicTaskList: any;
  selectAllPeriodicTask(event) {
    this.cnt = 0;
    if (event.target.checked == true) {
      this.cnt = this.cnt + 1;
      this.periodicTaskCheck = true
      console.log('checking for the datatable', $('#PeriodicTaskDataTable').DataTable().column(0, { search: 'applied' }).data())
      var filterValue = $('#PeriodicTaskDataTable').DataTable().column(0, { search: 'applied' }).data();
      if (_.size(filterValue)) {
        for (let index = 0; index < _.size(filterValue); index++) {
          var indexOfPeriodicTask = _.findIndex(this.periodicTaskList, function (element) { return element.TaskID == filterValue[index] });
          this.periodicTaskList[indexOfPeriodicTask].SelectedTask = true
          if (this.periodicTaskList[indexOfPeriodicTask].IsActive) {
            this.deactivatedTaskCount = this.deactivatedTaskCount + 1;
          }
          if (!this.periodicTaskList[indexOfPeriodicTask].IsActive) {
            this.activatedTaskCount = this.activatedTaskCount + 1;
          }
        }
        this.checkAllPeriodicTask = true

      } else {
        for (let index = 0; index < _.size(this.periodicTaskList); index++) {
          this.periodicTaskList[index].SelectedTask = true
          if (this.periodicTaskList[index].IsActive) {
            this.deactivatedTaskCount = this.deactivatedTaskCount + 1;
          }
          if (!this.periodicTaskList[index].IsActive) {
            this.activatedTaskCount = this.activatedTaskCount + 1;
          }
        }
        this.checkAllPeriodicTask = true
      }
      // else if(this.checkAllPeriodicTask) {

      // } else {

      // }
      // this.checkAllPeriodicTask = this.periodicTaskList.forEach(element => {
      //   // console.log(element.IsActive);
      //   if (element.IsActive) {
      //     this.deactivatedTaskCount = this.deactivatedTaskCount + 1;
      //   }
      //   if (!element.IsActive) {
      //     this.activatedTaskCount = this.activatedTaskCount + 1;
      //   }
      //   element.SelectedTask = true;
      // })

    } else {
      this.periodicTaskCheck = false
      this.cnt = this.cnt - 1;
      this.activatedTaskCount = 0;
      this.deactivatedTaskCount = 0;
      // this.checkAllPeriodicTask = false;

      this.checkAllPeriodicTask = this.periodicTaskList.forEach(element => {
        element.SelectedTask = false;
        for (var i = 0; i < this.periodicTaskList.length; i++) {
          this.periodicTaskList[i].SelectedTask = this.checkAllPeriodicTask;
        }
      })
    }


  }

  // Select all Event task
  selectcheckboxForEvent() {

    // console.log('mangesh=============', mangesh);
    // if(unchekedTask){
    //   this.addToProcessEventTask = true;
    // }else{
    //   this.addToProcessEventTask = true;
    // }
    this.selectedAllEventTask = this.libraryEventBasedTaskList.every(function (item: any) {
      return item.SelectedTask == true;
    })

  }

  checkIfAllSelectedEvent() {
    console.log('this.dtElementforEventBasedTask', this.libraryEventBasedTaskList, $('#eventLiberyTaskTable').DataTable().column(0, { search: 'applied' }).data())

    // this.dtElements.forEach(element => {
    //   console.log('every element', element)
    // })
    var filterValues = $('#eventLiberyTaskTable').DataTable().column(0, { search: 'applied' }).data()
    if (_.size(filterValues) && this.selectedAllEventTask) {
      for (let index = 0; index < _.size(filterValues); index++) {
        var indexOfEventTaskElement = _.findIndex(this.libraryEventBasedTaskList, function (element) { return element.TaskID == filterValues[index] })
        // console.log('indexOfEventTaskElement', indexOfEventTaskElement)
        this.libraryEventBasedTaskList[indexOfEventTaskElement].SelectedTask = true
      }
      this.addToProcessEventTask = true;
      this.IsSelectedTasks = true;
    } else if (this.selectedAllEventTask) {
      this.addToProcessEventTask = true;
      this.IsSelectedTasks = true;
      for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
        this.libraryEventBasedTaskList[i].SelectedTask = this.selectedAllEventTask;
      }
    } else {
      for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
        this.libraryEventBasedTaskList[i].SelectedTask = false;
      }
      this.addToProcessEventTask = false;
    }

    // this.dtElementforEventBasedTask.dtInstance.then((dtInstance: DataTables.Api) => {
    //   var filterValues = dtInstance.column(0, { search: 'applied' }).data()
    //   if (_.size(filterValues) && this.selectedAllEventTask) {
    //     for(let index = 0; index < _.size(filterValues); index++) {
    //       var indexOfEventTaskElement = _.findIndex(this.libraryEventBasedTaskList, function(element) { return element._id == filterValues[index]})
    //       this.libraryEventBasedTaskList[index].SelectedTask = true
    //     }
    //   } else if(this.selectedAllEventTask){
    // this.addToProcessEventTask = true;
    // this.IsSelectedTasks = true;
    //     for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
    //       this.libraryEventBasedTaskList[i].SelectedTask = this.selectedAllEventTask;
    //     }
    //   } else {
    //     for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
    //       this.libraryEventBasedTaskList[i].SelectedTask = false;
    //     }
    //   }
    // })

  }


  CheckProcessType(item: any) {
    this.processType = item;
    this.getProcessListByProcessType(this.processType);
  }


  getSelectedGroupID(ev) {
    this.response = false;
    var id = ev.target.value;
    this.groupID = id;
  }

  //Created on 18May
  getSelectedTaskStatus(ev) {
    this.taskStatus = ev.target.value;
    this.response = false;
  }

  initialiseJqueryEvents() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }

  deleteConfirmationEventBasedTask(taskId) {
    this.taskID = taskId
    $('#confirmationEventTask').modal('toggle');
  }


  deleteConfirmationPeriodicBasedTask(taskId) {
    this.taskID = taskId
    $('#confirmationEventTask').modal('toggle');
  }

  deactiatedPeriodicTask: any;
  ngOnInit(): void {
    $('[data-toggle="tooltip"]').tooltip();
    this.environmentSettings = environment;
    this.deactiatedPeriodicTask = false;
    this.addToProcessEventTask = false;
    this.IsSelectedTasks = false;
    this.response = false;
    var hasEditPermission: any = false;
    this.hasPermission = this.commonFunction.validateURL('LibraryTask', '');

    // this.sharerService.getClientIp().subscribe((response) => {
    //   console.log('responseresponseresponse', JSON.parse(response['_body']))
    //   var ip = JSON.parse(response['_body']).ip;
    //   this.ipLocalPc = ip
    // });

    this.initialiseJqueryEvents();
    // this.commonFunction.removeDataTableSaveStateKey("companytaskTable");

    this.getGroupmasterList();
    this.getProcessList();
    // Initialize users list cache early to prevent multiple calls
    this.getCachedUsersList();
    this.getassignedUsersList();
    this.getPeriodicTaskConfiguration();
    this.getUserList();
    this.getTriggerTypeListByTriggerType('Event');

    // let searchflag = localStorage.getItem('false');
    let searchflag = null;

    var searchnewdata = JSON.parse(localStorage.getItem('companyinputdata'));
    let roles = JSON.parse(localStorage.getItem('user')).Roles.map(role => role.RoleName)
    let TaskMaker = roles.includes('Task Checker');
    let TaskMakerAdmin = roles.includes('Admin');
    if (TaskMaker > 0 || TaskMakerAdmin>0) {
      setTimeout(() => {
        this.isCheckerRole = true;
        this.cdRef.detectChanges(); // trigger Angular to update the view
      }, 0);
    } else {
      this.isCheckerRole = false;
    }

    if (searchflag == 'true') {
      // console.log(" inside search flag searchnewdata", searchnewdata);
      this.searchParam = searchnewdata;
      this.companyTaskListBySearchFilter(this.searchParam);
    }
    else {
      this.getCompanyTaskList();

    }

    $(".dt-toolbar").hide();


    this.dtOptionsforPeriodicTask = {
      destroy: true,
      retrieve: true,
      autoWidth: false,
      searching: true,
      paging: true,
      info: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      stateSave: true,
      pagingType: 'full_numbers',
      pageLength: 5,
      search: true,
      order: [5, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1, 6] }],
      // Declare the use of the extension in the dom parameter
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Library Periodic Based Task List',
          title: 'Library Periodic Based Task List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 3, 4, 5, 7, 8, 9, 10],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          }

        }
      ]

    };

    this.dtOptionsEventBasedTask = {
      destroy: true,
      retrieve: true,
      autoWidth: false,
      searching: true,
      paging: true,
      info: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      stateSave: true,
      pagingType: 'full_numbers',
      pageLength: 5,
      search: true,
      order: [5, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1, 6] }],
      // Declare the use of the extension in the dom parameter
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Library Event Based Task List',
          title: 'Library Event Based Task List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 3, 4, 5, 7, 8, 9, 10],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          }

        }
      ]

    };

    $('#eventLiberyTaskTable').on('draw.dt', function () {
      $(".dt-toolbar").show();
    });



    this.activateTasksForm = new FormGroup({
      TaskParticulars: new FormControl('', [Validators.required]),
      ProcessID: new FormControl('', []),
      IsPredefinedorUserdefined: new FormControl('', []),
      TaskStatus: new FormControl('', [])
    });

    this.taskConfigurationForm = new FormGroup({
      EmailId: new FormControl('', []),
      FirstName: new FormControl('', []),
      LastName: new FormControl('', []),
      MobileNumber: new FormControl('', []),
      UserId: new FormControl('', [Validators.required])
    });

    this.taskStatus = "";
    this.countOfDeSelectedtask = 0;
    this.countOfSelectedtask = 0;


    var self = this;
    setTimeout(function () {

      let table1 = $("#eventLiberyTaskTable").DataTable();
      let searchedDataForSelectAll = [];

      table1.on('search.dt', function () {
        self.searcheFilteredDataTask = [];
        let tableData = $("#eventLiberyTaskTable").DataTable().column(0, { search: 'applied' }).data();
        for (let i = 0; i < tableData.length; i++) {
          self.searcheFilteredDataTask.push(tableData[i])
        }
        let alreadySelectedElamant = _.filter(self.libraryEventBasedTaskList, function (element) { return element.SelectedTask == true })
        let filterEventLibraryTaskList = []
        for (let index = 0; index < tableData.length; index++) {
          let taskList = _.filter(self.libraryEventBasedTaskList, function (element) { return element.SelectedTask == true && element.TaskID == tableData[index] })
          filterEventLibraryTaskList = _.concat(filterEventLibraryTaskList, taskList)
        }

        let value = $('.dataTables_filter input').val();
        if (_.size(alreadySelectedElamant) == _.size(tableData)) {
          self.selectedAllEventTask = true;
        } else if ((_.size(filterEventLibraryTaskList) == _.size(tableData)) && _.size(tableData) != 0 && _.size(filterEventLibraryTaskList) != 0) {
          self.selectedAllEventTask = true;
        } else {
          self.selectedAllEventTask = false;
        }
      });
    }, 3000);

    setTimeout(function () {

      let table1 = $("#PeriodicTaskDataTable").DataTable();
      let searchedDataForSelectAll = [];
      self.deactivatedTaskCount = 0;
      self.activatedTaskCount = 0;
      table1.on('search.dt', function () {
        self.searcheFilteredDataTask = [];
        let tableData = $("#PeriodicTaskDataTable").DataTable().column(0, { search: 'applied' }).data();
        for (let i = 0; i < tableData.length; i++) {
          self.searcheFilteredDataTask.push(tableData[i])
        }
        let alreadySelectedElamant = _.filter(self.periodicTaskList, function (element) { return element.SelectedTask == true })
        let filterperiodicTaskList = []
        for (let index = 0; index < tableData.length; index++) {
          let taskList = _.filter(self.periodicTaskList, function (element) { return element.SelectedTask == true && element.TaskID == tableData[index] })
          filterperiodicTaskList = _.concat(filterperiodicTaskList, taskList)
        }

        for (let indexOffilterTask = 0; indexOffilterTask < _.size(filterperiodicTaskList); indexOffilterTask++) {
          if (filterperiodicTaskList[indexOffilterTask].IsActive) {
            self.deactivatedTaskCount = self.deactivatedTaskCount + 1;
          }
          if (!filterperiodicTaskList[indexOffilterTask].IsActive) {
            self.activatedTaskCount = self.activatedTaskCount + 1;
          }
        }
        /*
        if (this.periodicTaskList[indexOfPeriodicTask].IsActive) {
                    this.deactivatedTaskCount = this.deactivatedTaskCount + 1;
                  }
                  if (!this.periodicTaskList[indexOfPeriodicTask].IsActive) {
                    this.activatedTaskCount = this.activatedTaskCount + 1;
                  }
        
        
        
        
        */
        let value = $('.dataTables_filter input').val();
        if (_.size(alreadySelectedElamant) == _.size(tableData)) {
          self.checkAllPeriodicTask = true;
        } else if ((_.size(filterperiodicTaskList) == _.size(tableData)) && _.size(tableData) != 0 && _.size(filterperiodicTaskList) != 0) {
          self.checkAllPeriodicTask = true;
        } else {
          self.checkAllPeriodicTask = false;
        }
      });
    }, 3000);


  }



  getlistbypromise(): Promise<any> {

    return this.taskService.getCompanyLibraryTaskList()
      .toPromise().then(res => {
        return Promise.resolve(res);

      })

  }

  onclickPeriodicTask() {
    // Data comes from this.periodicTaskList which was loaded during initial getCompanyTaskList() call
    // No service call needed - just ensure DataTable is properly displayed with existing cached data
    setTimeout(() => {
      if ($.fn.dataTable.isDataTable('#PeriodicTaskDataTable')) {
        $('#PeriodicTaskDataTable').DataTable().columns.adjust().draw();
      } else if (this.periodicTaskList && this.periodicTaskList.length > 0) {
        // If DataTable not initialized but data exists, trigger it
        this.dtTriggerforPeriodicTask.next();
      }
    }, 200);
  }

  onclickEventTask() {
    // Data comes from this.libraryEventBasedTaskList which was loaded during initial getCompanyTaskList() call
    // No service call needed - just ensure DataTable is properly displayed with existing cached data
    setTimeout(() => {
      if ($.fn.dataTable.isDataTable('#eventLiberyTaskTable')) {
      $("#eventLiberyTaskTable").DataTable().columns.adjust().draw();
      } else if (this.libraryEventBasedTaskList && this.libraryEventBasedTaskList.length > 0) {
        // If DataTable not initialized but data exists, trigger it
        this.dtTriggerEventBasedTask.next();
      }
    }, 200);
  }

  periodicSerchDefindTask() {
    this.response = false;
  }

  enableSearchButton() {
    this.response = false;
  }
  isEnableButtonSearch() {
    this.response = false;
  }

  /* Changes for configuration of periodic task (12-03-2019)*/
  getassignedUsersList() {
    this.assignedusers = [];

    // Use cached Observable instead of direct service call
    this.getCachedUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Assigned to"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })
          } else {
            this.assignedusers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
        }
      })
  }

  selectedUserChange() {
    var self = this;
    var userId = this.taskConfigurationForm.controls.UserId.value
    _.forEach(this.assignedusers, function (user) {
      var foundResource = [user].filter(function (element) {
        return element._id == userId;
      });

      if (foundResource[0] != undefined) {
        self.taskConfigurationForm.controls.EmailId.setValue(foundResource[0].EmailId);
        self.taskConfigurationForm.controls.FirstName.setValue(foundResource[0].FirstName);
        self.taskConfigurationForm.controls.LastName.setValue(foundResource[0].LastName);
        self.taskConfigurationForm.controls.MobileNumber.setValue(foundResource[0].MobileNumber);

      }
    })
  }

  addPeriodicTaskConfiguration() {
    this.disabledOnclick = true;
    if (this.configId == '' || this.configId == undefined || this.configId == null) {
      var configAddObject = {
        AssignedUserId: this.taskConfigurationForm.controls.UserId.value,
        AssignedFirstName: this.taskConfigurationForm.controls.FirstName.value,
        AssignedLastName: this.taskConfigurationForm.controls.LastName.value,
        AssignedMobileNumber: this.taskConfigurationForm.controls.MobileNumber.value,
        AssignedEmailId: this.taskConfigurationForm.controls.EmailId.value
      }
      this.taskService.addPeriodicTaskConfiguration(configAddObject)
        .subscribe(result => {
          this.disabledOnclick = false;
          if (result.status == 0) {
            $('#configureSettingsDialog').modal('toggle');
            this.alert.success(result.message);
            this.getPeriodicTaskConfiguration();
          }
          else {
            this.alert.error(result.message);
          }
        });
    } else {
      var configUpdateObject = {
        AssignedUserId: this.taskConfigurationForm.controls.UserId.value,
        AssignedFirstName: this.taskConfigurationForm.controls.FirstName.value,
        AssignedLastName: this.taskConfigurationForm.controls.LastName.value,
        AssignedMobileNumber: this.taskConfigurationForm.controls.MobileNumber.value,
        AssignedEmailId: this.taskConfigurationForm.controls.EmailId.value
      }
      this.taskService.updatePeriodicTaskConfiguration(this.configId, configUpdateObject)
        .subscribe(result => {
          if (result.status == 0) {
            $('#configureSettingsDialog').modal('toggle');
            this.alert.success(result.message);
            this.getPeriodicTaskConfiguration();
          }
          else {
            this.alert.error(result.message);
          }
        });
    }

  }

  getPeriodicTaskConfiguration() {
    this.taskService.getPeriodicTaskConfiguration().subscribe(result => {
      if (result.data.length > 0) {
        var configData = result.data[0];
        this.isPeriodicConfigurationAvailable = false;
        this.configId = result.data[0]._id;
        this.taskConfigurationForm.controls.UserId.setValue(configData.PeriodicTaskConfiguration.AssignedUserId);
        this.taskConfigurationForm.controls.FirstName.setValue(configData.PeriodicTaskConfiguration.AssignedFirstName);
        this.taskConfigurationForm.controls.LastName.setValue(configData.PeriodicTaskConfiguration.AssignedLastName);
        this.taskConfigurationForm.controls.MobileNumber.setValue(configData.PeriodicTaskConfiguration.AssignedMobileNumber);
        this.taskConfigurationForm.controls.EmailId.setValue(configData.PeriodicTaskConfiguration.AssignedEmailId);
      }
    })
  }

  getTriggerTypeListByTriggerType(triggerType) {
    this.taskTriggerTypes = [];

    // Cache the Observable to prevent multiple HTTP calls
    let cachedObservable$: Observable<any> | null = null;
    if (triggerType === 'Periodic') {
      console.log('triggerType12', triggerType)
      if (!this.cachedPeriodicTriggerTypes$) {
        this.cachedPeriodicTriggerTypes$ = this.taskService.getTriggerTypeListByTriggerType(triggerType).pipe(shareReplay(1));
      }
      cachedObservable$ = this.cachedPeriodicTriggerTypes$;
    } else if (triggerType === 'Event') {
      console.log('triggerType132', triggerType)
      if (!this.cachedEventTriggerTypes$) {
        this.cachedEventTriggerTypes$ = this.taskService.getTriggerTypeListByTriggerType(triggerType).pipe(shareReplay(1));
      }
      cachedObservable$ = this.cachedEventTriggerTypes$;
    } else {
      // Fallback for other trigger types
      console.log('triggerType', triggerType)
      cachedObservable$ = this.taskService.getTriggerTypeListByTriggerType(triggerType).pipe(shareReplay(1));
    }

    cachedObservable$.subscribe(tasktriggerList => {
      if (tasktriggerList.status == 0) {
        this.taskTriggerTypes = tasktriggerList.tasktriggerList;
      }
    })
  }

  approveTaskStatusConfirmation(taskId, type) {
    this.approveCheck = null;
    this.taskRejectComment = "";
    this.taskParticulars = "";
    if (type == 'delete') {
      this.deleteConfirmationEventBasedTask(taskId)
    } else {
      this.approveStatusId = taskId;
      this.approveBtnType = 'single';
      this.saveType = type;
      $('#approveTaskStatusDialog').modal('toggle');
    }
    // console.log(type)
    // if (type == 'add') {
    //   $('#approveTaskStatusDialog').modal('toggle');
    // } else if (type == 'addAndActivate') {

    // } else if (type == 'update') {
    //   $('#approveTaskStatusDialog').modal('toggle');
    // } else if (type == 'updateAndActivate') {

    // }
  }

  approveTask() {
    if (this.approveCheck == true && (this.taskParticulars == "" || this.taskParticulars == null || this.taskParticulars == undefined)) {
      this.alert.error('Task Particulars field is required');
    } else {
      var object = {
        taskId: this.approveStatusId,
        approveCheck: this.approveCheck,
        taskRejectComment: this.taskRejectComment,
        IPAddress: this.ipLocalPc,
        isRejected: (this.approveCheck == false || this.approveCheck == 'false') ? true : false,
        saveType: this.saveType,
        taskParticulars: this.taskParticulars
      }
      this.taskService.approveTask(object)
        .subscribe(response => {
          if (response.status == 0) {
            this.showAllPeriodicTasks();
            this.showAllEventTasks();
            $('#approveTaskStatusDialog').modal('toggle');
            if (this.approveCheck == 'true' || this.approveCheck == true) {
              this.alert.success('Task approved successfully')
            } else {
              this.alert.success('Task rejected successfully')
            }

          }
        })
    }
  }

  approveMultipleTasksConfirmation(type) {
    this.approveCheck = null;
    this.taskRejectComment = "";
    this.taskParticulars = "";
    this.approveBtnType = 'multi';
    this.approveMultipleBtnType = type;
    $('#approveTaskStatusDialog').modal('toggle');
  }

  approveMultipleTasks() {
    // this.response = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;
    this.selectedCompanytasks = [];
    if (this.approveMultipleBtnType == 'event') {
      for (let result of this.libraryEventBasedTaskList) {
        if (result.SelectedTask === true) {
          this.selectedCompanytasks.push(result);
        }

      }
    } else if (this.approveMultipleBtnType == 'periodic') {
      for (let result of this.periodicTaskList) {
        // console.log('result.SelectedTask', result.SelectedTask);
        if (result.SelectedTask === true) {
          this.selectedCompanytasks.push(result);
        }
      }
    }


    var object = {
      taskDetails: this.selectedCompanytasks,
      approveCheck: this.approveCheck,
      taskRejectComment: this.taskRejectComment,
      IPAddress: this.ipLocalPc,
      isRejected: (this.approveCheck == false || this.approveCheck == 'false') ? true : false,
      // saveType: this.saveType
    }
    //this.taskService.updateCompanyTasks(companyTasks)
    this.taskService.approveMultipleTask(object)
      .subscribe(result => {

        if (result.status == 0) {
          this.showAllPeriodicTasks();
          this.showAllEventTasks();
          $('#approveTaskStatusDialog').modal('toggle');
          if (this.approveCheck == 'true' || this.approveCheck == true) {
            this.alert.success('Tasks approved successfully')
          } else {
            this.alert.success('Tasks rejected successfully')
          }

        }

      });
  }

}
